<template>
  <v-navigation-drawer v-model="drawer" absolute class="primary " dark>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title
          ><br /><br /><br /><b>CONFIGURAÇÕES</b><br /><br
        /></v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item link @click="edit = !edit">
        <v-list-item-icon>
          <v-icon>mdi-account-edit</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>EDITAR PERFIL</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item @click="beforeEdit()">
        <v-list-item-icon>
          <v-icon>mdi-calendar-month-outline</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>CADASTRAR HORÁRIOS</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-list-item link @click="$store.dispatch('logout')">
        <v-list-item-icon>
          <v-icon>mdi-exit-run</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>SAIR</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <EditProfessorDialog
      :visibility="edit"
      @negative="edit = !edit"
      @positive="onProfessorEdit"
      :profile="userProfile"
    />

    <v-dialog v-model="cant_edit" persistent width="500px">
      <v-card>
        <v-layout
          justify-center=""
        >
          <v-card-title>
            <center>
              <span> Ops... Função Bloqueada </span>
            </center>
          </v-card-title>
        </v-layout>

        <v-card-text class="pt-5 pb-5">
          <center>
            No momento não é permitido que professores alterem sua agenda de horários desponíveis para dar aulas. Para mais informações contate os administradores.
          </center>
        </v-card-text>
        <v-card-actions class="pt-5 pb-5">
          <v-btn
            class="full-width primary"
            depressed
            rounded
            @click="cant_edit = !cant_edit"
          >
            Sair
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </v-navigation-drawer>


</template>

<script>
import EditProfessorDialog from "@/components/dialogs/EditProfessorDialog";
import { mapState } from "vuex";
import ProfileServiceMixin from "@/mixins/services/ProfileServiceMixin";
export default {
  mixins: [ProfileServiceMixin],

  components: {
    EditProfessorDialog
  },

  props: {
    visibility: Boolean
  },

  data() {
    return {
      edit: undefined,
      drawer: undefined,
      cant_edit: false
    };
  },

  computed: {
    ...mapState(["userProfile"])
  },

  watch: {

    visibility: {
      immediate: true,
      handler(val) {
        this.drawer = val;
      }
    },

    drawer: {
      handler(val) {
        this.$emit("closed", val);
      }
    }
  },

  methods: {
    async onProfessorEdit(professor) {
      await this.onStudentEdit(professor);
      this.edit = !this.edit;
      location.reload();
    },

    beforeEdit() {
      if ( !this.userProfile.user.edit_schedule ) {
        this.cant_edit = true

      } else {
        this.cant_edit = false
        this.$router.push("/cadastro-aulas")
      }
    }

  }
};
</script>


<style scoped>
  .full-width {
    width: 100%;
  }

  .position-title {
    position: relative;
    left: 40%;
  }
</style>
